import { render } from "./vagentordercount.vue?vue&type=template&id=32f2aafe&scoped=true"
import script from "./vagentordercount.vue?vue&type=script&lang=js"
export * from "./vagentordercount.vue?vue&type=script&lang=js"

import "./vagentordercount.vue?vue&type=style&index=0&id=32f2aafe&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f2aafe"]])

export default __exports__